import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faShoppingCart,
  faBell,
  faLocationDot,
  faUser,
  faHeart,
} from '@fortawesome/free-solid-svg-icons';
import './d-Postnav.css';
import './m-Postnav.css';
import Cookies from 'js-cookie';

function Postnav() {
  const [nombre, setNombre] = useState('');
  const [direccion, setDireccion] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      const nombreCookie = Cookies.get('nombre');
      const direccionCookie = Cookies.get('direccion');

      if (nombreCookie && direccionCookie) {
        setNombre(nombreCookie);
        setDireccion(direccionCookie);
      } else {
        try {
          const url = `${window.location.origin}/api/infocuentas`;
          const response = await fetch(url);
          const data = await response.json();

          if (data.nombre) {
            Cookies.set('nombre', data.nombre);
            setNombre(data.nombre);
          } else {
            setNombre('');
          }

          if (data.direccion) {
            Cookies.set('direccion', data.direccion);
            setDireccion(data.direccion);
          } else {
            setDireccion('');
          }
        } catch (error) {
          setNombre('');
          setDireccion('');
        }
      }
    };

    fetchData();
  }, []);

  return (
    <div className="postnav">
      <div className="postnav-full-container">
        <div className="postnav-center-container">
          <div className="postnav-content">
            <div className="postnav-chip postnav-location-chip">
              <span className="postnav-chip-icon">
                <FontAwesomeIcon icon={faLocationDot} />
              </span>
              <div className="postnav-chip-copy">
                <small>Enviar a</small>
                <strong>{direccion || 'Elegí tu ubicación'}</strong>
              </div>
            </div>

            <div className="postnav-chip postnav-account-chip">
              <span className="postnav-chip-icon">
                <FontAwesomeIcon icon={faUser} />
              </span>
              <div className="postnav-chip-copy">
                <small>Cuenta</small>
                <strong>{nombre || 'Ingresá o creá tu cuenta'}</strong>
              </div>
            </div>

            <div className="postnav-links">
              <Link to="/cuenta#MisCompras" className="postnav-link-pill">Mis Compras</Link>
              <Link to="/cuenta#MisDatos" className="postnav-link-pill">Mi Perfil</Link>
              <Link to="/productos" className="postnav-link-pill postnav-link-strong">Ver catalogo</Link>
            </div>

            <div className="postnav-actions">
              <Link to="/tucarrito" className="postnav-action-icon" aria-label="Carrito">
                <FontAwesomeIcon icon={faShoppingCart} />
              </Link>
              <button type="button" className="postnav-action-icon" aria-label="Favoritos">
                <FontAwesomeIcon icon={faHeart} />
              </button>
              <button type="button" className="postnav-action-icon" aria-label="Notificaciones">
                <FontAwesomeIcon icon={faBell} />
              </button>
            </div>

            <div className="m-postnav-center-lupa">
              <div className="m-postnav-chip-grid">
                <div className="postnav-chip postnav-location-chip">
                  <span className="postnav-chip-icon">
                    <FontAwesomeIcon icon={faLocationDot} />
                  </span>
                  <div className="postnav-chip-copy">
                    <small>Enviar a</small>
                    <strong>{direccion || 'Elegí tu ubicación'}</strong>
                  </div>
                </div>
                <div className="postnav-chip postnav-account-chip">
                  <span className="postnav-chip-icon">
                    <FontAwesomeIcon icon={faUser} />
                  </span>
                  <div className="postnav-chip-copy">
                    <small>Cuenta</small>
                    <strong>{nombre || 'Ingresá o creá tu cuenta'}</strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Postnav;
